import React, { Fragment, useEffect, useState } from "react";
import {
    Form,
    FormGroup,
    Input,
    Label,
    Button,
    FormFeedback
} from "reactstrap";
import { connect } from "react-redux";
import Message from "../../../CommonData/Data/Message.js";
import { updateForm } from "../../../store/form/actions.js";
import VWLoading from "../../../components/vwLoading/vwLoading.js";
import {
    addReturnReason,
    clearCreateReturnReasonError,
    createReturnReason
} from "../../../store/settings/returnReason/actions.js";

const AddReturnReason = (props) => {

    const { handleClose, errorMessage, form, isCreatePending } = props;
    const { AddReturnReasonForm } = form || {};
    const { reason } = AddReturnReasonForm || {};

    useEffect(() => {
        props.updateForm({
            AddReturnReasonForm: {},
            errors: {}
        })
        props.clearCreateReturnReasonError();
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        props.updateForm({
            AddReturnReasonForm: {
                ...form.AddReturnReasonForm,
                [name]: value
            },
            errors: {
                ...form && form.errors,
                [name]: null,
            }
        });
    }

    const handleCreateProduct = (e) => {
        e.preventDefault();
        const { AddReturnReasonForm } = form || {};
        const { reason } = AddReturnReasonForm || {};
        const currentErrors = {};

        if (!reason) {
            currentErrors.reason = "Name is required"
        }

        props.updateForm({
            AddReturnReasonForm: {
                ...form.AddReturnReasonForm,
            },
            errors: currentErrors,
        })

        if (Object.keys(currentErrors).length === 0) {
            props.createReturnReason(form.AddReturnReasonForm);
        }
    };

    return isCreatePending ? (<VWLoading />) : (
        <Fragment>
            {errorMessage && (
                <Message
                    type="danger"
                    defaultMessage={errorMessage}
                    baseClassName="alert"
                />
            )}
            <Form onSubmit={handleCreateProduct}>
                <FormGroup>
                    <Label>Reason</Label><span className="text-danger">*</span>
                    <Input
                        autoFocus
                        type="text"
                        name="reason"
                        placeholder="Enter reason"
                        onChange={handleInputChange}
                        value={reason || ""}
                        invalid={form && form.errors && form.errors.reason}
                    />
                    <FormFeedback>{form && form.errors && form.errors.reason}</FormFeedback>
                </FormGroup>
                <Button
                    type="submit"
                    className='me-4'
                    color="success"
                    onClick={handleCreateProduct}
                >
                    Create
                </Button>
                <Button
                    color="danger"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
            </Form>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    form: state.form.form,
    AddReturnReasonForm: state.returnReason.AddReturnReasonForm,
    isCreatePending: state.returnReason.isReturnReasonCreatePending,
    errorMessage: state.returnReason.returnReasonCreateError,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (AddReturnReasonForm) => dispatch(updateForm(AddReturnReasonForm)),
    addProduct: (AddReturnReasonForm) => dispatch(addReturnReason(AddReturnReasonForm)),
    clearCreateReturnReasonError: () => dispatch(clearCreateReturnReasonError()),
    createReturnReason: (AddReturnReason) => dispatch(createReturnReason(AddReturnReason)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReturnReason);